import React from 'react'
import ReactDOM from 'react-dom/client'
import { I18nextProvider } from 'react-i18next'
// Components
import AuthProvider from './authService/AuthProvider'
import authService from 'authService'
import QueryProvider from './QueryProvider'
import ThemeProvider from './ThemeProvider'
import Root from 'containers'
// styles
import './index.css'
import i18n from 'location'

authService.verifyCredentials()

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <AuthProvider>
      <QueryProvider>
        <ThemeProvider>
          <I18nextProvider i18n={i18n}>
            <Root />
          </I18nextProvider>
        </ThemeProvider>
      </QueryProvider>
    </AuthProvider>
  </React.StrictMode>
)
